<div class="tabs-module-wrapper">
  <ul class="tabs-module tabs-module--with-border tabs-module--revised tabs-module--card">
    <li *ngFor="let option of options;">
      <a  class="tabs-module__tabs"
         [ngClass]="{'tabs-module__tabs--active': option.isActive,'disabled': !option.enabled}"
         (click)="onOptionChange(option.id)">
        <span>{{ option.name }}</span>
      </a>
    </li>
  </ul>
</div>
